import * as actionTypes from "./../../Constants/actionTypes";
import moment from "moment";

import API from "./../../Constants/API";
import * as usersServices from "../../services/users/index";
import { types } from "util";
import mapUserDetailsToLookup from "../../Common/Utility/mapUserDetailsToLookup";
import mapBulkUpdateUsersToLookup from "../../Common/Utility/mapBulkUpdateUsersToLookup";

// INLINE GRID UPDATE ACTION
export const inlineUpdates = (updatedUsers, isEdited, isLoading, allUsers) => ({
    type: actionTypes.GRID_UPDATE,
    payload: { updatedUsers, isEdited, isLoading, allUsers }
});

export function gridUpdate(newUpdatedUsers, isEdited, isLoading, allUsers) {
    return async dispatch => {
        // const request = await usersServices.req.saveGridChanges(
        //   API.updateUsersInGrid,
        //   updates
        // );

        return dispatch(inlineUpdates(newUpdatedUsers, isEdited, isLoading, allUsers));
    };
}

// ENABLE DISABLE USER ACCOUNT STATUS ACTION
// export const userAccountStatus = activeInactiveDataobj => ({
//   type: actionTypes.ENABLE_DISABLE_USERS,
//   payload: { activeInactiveDataobj }
// });

export function userAccountStatusUpdate(activeInactiveDataobj, allUsers) {
    return async dispatch => {
        const request = await usersServices.req.updateUserAccountStatus(
            API.enableDisableUsers,
            activeInactiveDataobj
        );
        if (request) {
            let changedUser = activeInactiveDataobj.useriddetail.split(',');
            allUsers = allUsers.map((user) => {
                if (changedUser.includes((user.user_id).toString())) {
                    user.account_disabled = activeInactiveDataobj.account_disabled === 'Y' ? "Inactive" : "Active";
                    user.selected = activeInactiveDataobj.account_disabled === 'Y' ? false : false;
                }
                return user;
            });

            dispatch({
                type: actionTypes.ENABLE_DISABLE_USERS,
                payload: {
                    selectedUsersIds: [],
                    selectedUsersStatus: [],
                    allUsers
                }
            });
        }
    };
}

// BULK UPDATE ACTION
export const bulkUpdates = (bulkUpdatedUsers) => ({
    type: actionTypes.BULK_UPDATE_USERS,
    payload: { bulkUpdatedUsers }
});

export function bulkUpdateUsers(updatedUserObj, allUsers, lookup) {
    return async dispatch => {
        const request = await usersServices.req.updateBulkeditChanges(
            API.bulkUpdate,
            updatedUserObj
        );

        if (request.isSuccess) {
            let mappedBulkUpdateData = mapBulkUpdateUsersToLookup(
                updatedUserObj,
                lookup,
                allUsers
            );
            dispatch({
                type: actionTypes.BULK_UPDATE_USERS,
                payload: {
                    selectedUsersIds: [],
                    selectedUsersStatus: [],
                    allUsers: mappedBulkUpdateData
                }
            });
            //return dispatch(bulkUpdates(updatedUserObj, allUsers));
        }
        return request;
    };
}

export function clearBulkUpdateData() {
    return async dispatch => {
        return dispatch(bulkUpdates({}));
    };
}

// GET LOOKUP DATA ACTION
export const lookups = lookupData => ({
    type: actionTypes.GET_LOOKUP_DATA,
    payload: lookupData
});

export function fetchLookupData(firmId) {
    return async dispatch => {
        const request = await usersServices.req.getLookupData(
            API.getLookup,
            firmId
        );
        Array.prototype.move = function (from, to) {
            this.splice(to, 0, this.splice(from, 1)[0]);
        };
        request.generationList.move(5, 6)
        return dispatch(lookups(request));
    };
}

export function getAllUsers(firmId, branchId, globalUser, lookup, categories) {
    return async dispatch => {
        const usersData = await usersServices.req.getUsersData(
            API.getUsers,
            firmId,
            branchId,
            globalUser
        );
        let mappedData = mapUserDetailsToLookup(lookup, usersData, categories);
        return dispatch({
            type: actionTypes.GET_ALL_USERS,
            payload: { mappedData }
        });
    };
}

// GET SELECTED USERS ACTION
export function selectedUsers(selectedUsersIds, selectedUsersStatus, isSortSelectedUsers) {
    return dispatch =>
        dispatch({
            payload: { selectedUsersIds, selectedUsersStatus, isSortSelectedUsers },
            type: actionTypes.GET_SELECTED_USERS
        });
}
// CLEAR SELECTED USERS
export function clearSelectedUsers(allUsers) {
    return dispatch =>
        dispatch({
            payload: { allUsers },
            type: actionTypes.CLEAR_SELECTED_USERS
        });
}

// RESET LOADING
export function resetLoading(isLoading) {
    return dispatch =>
        dispatch({
            payload: { isLoading },
            type: actionTypes.RESET_LOADING
        });
}


// REFRESH GRID ACTION
// export function refetchGridData(isRefresh, filterUserStatus, isEdited) {

//   return dispatch => {
//     return dispatch({
//       payload: { isRefresh, filterUserStatus, isEdited },
//       type: actionTypes.REFRESH_GRID_DATA
//     });
//   };
// }
// CLEAR FILTERS ACTION
export function clearAllFilters(isClearFilters, allUsers) {
    allUsers = allUsers.map((user) => {
        user.selected = false;
        return user;
    });

    return dispatch => {
        return dispatch({
            payload: { isClearFilters, allUsers },
            type: actionTypes.CLEAR_ALL_FILTERS
        });
    };
}

// Show Filter Icon
// export function showFilter(showFilterIcon) {
//   return dispatch => {
//     return dispatch({
//       payload: { showFilterIcon },
//       type: actionTypes.SHOW_FILTER_ICON
//     });
//   };
// }

// show Modal To Discard
// export function showModalToDiscard(isModalOpen, isEdited, updatedUsers = null) {
//   return dispatch => {
//     return dispatch({
//       payload: { isModalOpen, isEdited, updatedUsers },
//       type: actionTypes.SHOW_MODAL_TO_DISCARD
//     });
//   };
// }

//DISCARD CHANGES YES
export function discardChanges() {
    return dispatch =>
        dispatch({
            // payload: { isModalOpen, updatedUsers },
            type: actionTypes.DISCARD_CHANGES_YES
        });
}


// EXPORT TO EXCEL ACTION
export function exportToExcel(isExport) {
    return dispatch =>
        dispatch({
            payload: { isExport },
            type: actionTypes.EXPORT_TO_EXCEL
        });
}
// GET VISIBLE ROWS COUNT
export function getRowsCountAfterFilter(rowsCount) {
    return dispatch =>
        dispatch({
            payload: { rowsCount },
            type: actionTypes.ROWS_COUNT_AFTER_FILTER
        });
}

//MOVE SELECTED USERS TO TOP
export function sortBySelectedUsers(isSortSelectedUsers, finalSortedUsers) {
    return dispatch =>
        dispatch({
            payload: { isSortSelectedUsers, finalSortedUsers },
            type: actionTypes.SORT_SELECTED_USERS
        });
}

export function clearAllUsers() {
    return dispatch =>
        dispatch({
            payload: {},
            type: actionTypes.CLEAR_ALL_USERS
        });
}
export function getStaffReportDetails(firmId) {
    return async dispatch => {
        const staffReportData = await usersServices.req.getStaffReportData(API.getStaffReportDetails, firmId);
        return dispatch({
            type: actionTypes.GET_STAFF_REPORT_DATA,
            payload: { staffReportData }
        });
    };
}
export function fetchStaffLookupData(firmId) {
    return async dispatch => {
        const staffLookups = await usersServices.req.getStaffLookupData(API.getStafflookUpDetails, firmId);
        return dispatch({
            type: actionTypes.GET_STAFF_LOOKUP_DATA,
            payload: { staffLookups }
        });       
    };
}
export function fetchfirmLookUpDetails(firmId) {
    return async dispatch => {
        const firmLookups = await usersServices.req.getfirmLookupData(API.getfirmlookUpDetails, firmId);
        return dispatch({
            type: actionTypes.GET_FIRM_LOOKUP_DATA,
            payload: { firmLookups }            
        });        
    };
}

export function updateStaffIntegratedDetails(firmId) {
    return async dispatch => {
        const gracePdCount = await usersServices.req.updateStaffIntegratedData(API.updateStaffIntegratedDetails, firmId);
            return dispatch({
                type: actionTypes.UPDATE_GRACEPERIOD_DATA,
                payload: { gracePdCount }
            });
    };
}

export function getFirmGracePeriodDetails(firmId) {
    return async dispatch => {
        const gracePeriodData = await usersServices.req.getfirmGracePeriodData(API.getfirmGracePeriodDetails, firmId);
        return dispatch({
            type: actionTypes.GET_FIRM_GRACEPERIOD_DATA,
            payload: { gracePeriodData }
        });
    };
}
export function fetchIntegrationPhData(firmId) {
    return async dispatch => {
        const IntegrationPhase = await usersServices.req.getIntegrationPhData(API.getIntegrationPhDetails, firmId);
        return dispatch({
            type: actionTypes.GET_STAFF_INTPH_DATA,
            payload: { IntegrationPhase }
        });
    };
}
export function fetchLicenseDetails() {
    return async dispatch => {
        const LicenseData = await usersServices.req.getLicenseDetails(API.getWorkstreamLicenseDetails);
        return dispatch({
            type: actionTypes.GET_LICENSE_DATA,
            payload: { LicenseData }
        });
    };
}




